import Component from "@tunnel-components/@sharded/modal/changepassword/component";
import * as React from "react";
import { connect } from "react-redux";
import { ChangePassWordActionCreator } from "@tunnel-store/index";
import * as Lodash from "lodash";
import * as Utils from "@Cyclope-Utils/index";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name
 * @name componentWillReceiveProps
 * @name render
 * @infos "https://reactjs.org"
 */
class Container extends React.PureComponent<any, any> {
  //  faire cette action toute les 550 millisecondes
  public debounceChange = Lodash.debounce((event: any) => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      error: false,
      errorLength: false,
      loading: false,
      pwdNotModified: false,
      success: false,
    }));
    {
      /** Empêcher la mutation du state */
    }
    this.setState({ [event.target.name]: String(event.target.value) });
  }, 150);

  //  faire cette action toute les 550 millisecondes
  public debounceSubmit = Lodash.debounce((event: any) => {
    if (
      !Lodash.isEmpty(this.state.pwdConfirm) &&
      !Lodash.isEmpty(this.state.pwdHold) &&
      !Lodash.isEmpty(this.state.pwdNew)
    ) {
      if (!Lodash.isEqual(this.state.pwdNew, this.state.pwdHold)) {
        if (Lodash.isEqual(this.state.pwdNew, this.state.pwdConfirm)) {
          if (this.state.pwdNew.split("").length >= this.state.QUATRE) {
            if (
              Utils.validatorString(this.state.pwdNew) &&
              Utils.validatorString(this.state.pwdConfirm) &&
              Utils.validatorString(this.state.pwdConfirm)
            ) {
              this.props.ChangePassWordActionCreator(this.state);
            } else {
              {
                /** Empêcher la mutation du state */
              }
              this.setState((state: any): any => ({
                error: true,
                loading: false,
                pwdNotModified: true,
                success: false,
              }));
            }
          } else {
            {
              /** Empêcher la mutation du state */
            }
            this.setState((state: any): any => ({
              errorLength: true,
              error: false,
              loading: false,
              pwdNotModified: false,
              success: false,
            }));
          }
        } else {
          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any): any => ({
            error: true,
            loading: false,
            pwdNotModified: false,
            success: false,
          }));
        }
      } else {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          error: true,
          loading: false,
          pwdNotModified: false,
          success: false,
        }));
      }
    } else {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        error: true,
        loading: false,
        pwdNotModified: false,
        success: false,
      }));
    }
  }, 150);
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @description : possède des informations sur le composant
     * @property { object }               state
     */
    this.state = {
      QUATRE: 4,
      error: false,
      errorLength: false,
      pwdConfirm: "",
      pwdHold: "",
      pwdNew: "",
      pwdNotModified: false,
      success: false,
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque
     * initialisation des composants "seulement quand il y'a un event
     * exécuté"
     */
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  /**
   * Recupération des valeur des inputs
   * @method onChange
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onChange = (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    // Faire persister mon événement
    event.persist();

    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacé dans le temps
     */

    this.debounceChange(event);
  };
  /**
   * Envoir du formulaire
   * @method onSubmit
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onSubmit = (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.persist();

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      error: false,
      loading: true,
      success: false,
    }));
    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacé dans le temps
     */
    this.debounceSubmit(event);
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** comparaison */
    }
    if (nextProps.serverError !== this.props.serverError) {
      if (!Lodash.isUndefined(nextProps.serverError)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          error: true,
          loading: false,
          success: false,
          pwdNotModified: false,
        }));
      }
    } else if (nextProps.dataPwd !== this.props.dataPwd) {
      if (!Lodash.isUndefined(nextProps.dataPwd)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          error: false,
          loading: false,
          pwdNotModified: false,
          success: true,
        }));

        setTimeout(() => {
          this.setState((state: any): any => ({
            isVisible: false,
          }));
        }, 3000);
      }
    } else if (nextProps.isVisible !== this.props.isVisible) {
      if (nextProps.isVisible === false) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          error: false,
          errorLength: false,
          loading: false,
          pwdConfirm: "",
          pwdHold: "",
          pwdNew: "",
          pwdNotModified: false,
          success: false,
        }));
      }
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentDidUpdate
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } prevProps
   * @param { any } prevState
   * @infos "https://reactjs.org"
   */
  public componentDidUpdate(prevProps: any, prevState: any) {
    {
      /** Comparaison des props */
    }
    if (prevState.success !== this.state.success) {
      if (this.state.success) {
        setTimeout(() => {
          this.setState((state: any): any => ({
            isVisible: false,
          }));
        }, 3000);
      }
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillUnmount
   * @description : il est appelée.
   * Avant que le composant soit supprimé du DOM.
   * Cette méthode peut être utile lorsque vous devez effectuer
   * des opérations de nettoyage.
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentWillMount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      error: false,
      errorLength: false,
      loading: false,
      pwdConfirm: "",
      pwdHold: "",
      pwdNew: "",
      pwdNotModified: false,
      success: false,
    }));

    // Stopper l'action une fois le component détruit
    this.debounceChange.cancel();
    // Stopper l'action une fois le component détruit
    this.debounceSubmit.cancel();
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return (
      <Component
        onChange={this.onChange}
        {...this.state}
        {...this.props}
        onSubmit={this.onSubmit}
      />
    );
  }
}
/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  return {
    dataPwd: state.ChangePassWord.data,
    serverError: state.ChangePassWord.error,
  };
}

/** @export HOC conect */
export default connect(mapStateToProps, { ChangePassWordActionCreator })(
  Container
);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/modal/changepassword/container.tsx